export default {
  name: 'SamlLogin',
  displayName: {
    en: 'SSO Login',
    ja: 'SSOログイン',
  },
  defaultWidth: 343,
  defaultHeight: 40,
  resizeX: true,
  props: [
    {
      name: 'email',
      displayName: {
        en: 'Email address (required)',
        ja: 'メールアドレス（必須）',
      },
      type: 'userField',
    },
    {
      name: 'object_id',
      displayName: {
        en: 'Microsoft object ID (required)',
        ja: 'Microsoft オブジェクト ID（必須）',
      },
      type: 'userField',
    },
    {
      name: 'type',
      displayName: {
        en: 'Type',
        ja: 'タイプ',
      },
      type: 'text',
      default: 'contained',
      control: {
        type: 'menu',
        options: [
          {
            label: 'canvas.menuRight.elementTab.button.type.text',
            value: 'text',
          },
          {
            label: 'canvas.menuRight.elementTab.button.text.outline',
            value: 'outlined',
          },
          {
            label: 'canvas.menuRight.elementTab.button.text.button',
            value: 'contained',
          },
        ],
      },
    },
    {
      name: 'text',
      displayName: {
        en: 'Text',
        ja: 'テキスト',
      },
      type: 'text',
      default: 'Sign in with SSO',
      styles: {
        fontFamily: '@body',
        fontWeight: '600',
      },
    },
    {
      name: 'full_name',
      displayName: {
        en: 'Full name',
        ja: '氏名',
      },
      type: 'userField',
    },
    {
      name: 'username',
      displayName: {
        en: 'Username',
        ja: 'ユーザー名',
      },
      type: 'userField',
    },
    {
      name: 'action',
      type: 'action',
      displayName: {
        en: 'Button',
        ja: 'Button',
      },
    },
    {
      name: 'successActions',
      displayName: {
        en: 'Actions when SSO login succeeds',
        ja: 'SSOログイン成功時のアクション',
      },
      type: 'action',
    },
    {
      name: 'failedActions',
      displayName: {
        en: 'Actions when SSO login fails',
        ja: 'SSOログイン失敗時のアクション',
      },
      type: 'action',
    },
  ],
  style: {
    opacity: true,
    text: true,
    backgroundColor: true,
    borderRadius: true,
  },
};
